import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Zendesk Check Queue v1 Configuration Validator
 * Validates Zendesk queue check configuration
 */
export const Zendesk_Check_Queue_1_ConfigValidator = z.object({
    zendeskConnection: requiredString('Zendesk Connection is required'),
    phoneNumberIds: z.string().optional()
});
//# sourceMappingURL=zendesk-check-queue-1.js.map